module.exports = {
  select_community: 'Community auswählen',
  availableCommunities: 'Verfügbare Communities',
  createCommunityPostModalTitle: 'Post in der Community erstellen',
  createCommunityPost: 'Beitrag für die Community erstellen',
  communityMembers: 'Community-Mitglieder',
  managers: 'Manager',
  members: 'Mitglieder',
  searchMembers: 'Suchen',
  noMembersFound: 'Keine Mitglieder gefunden',
  description: 'Beschreibung',
  seeAll: 'Alle anzeigen',
  yourPost: 'Ihr Post',
  communityPost: 'Community Post',
  postActions: 'Post-Aktionen',
  showOnThread: 'Im Thread anzeigen',
  postDoesNotExist: 'Dieser Post existiert nicht',
  deletePost: {
    title: 'Post löschen?',
    confirmation: 'Dieser Post und alle Antworten werden dauerhaft gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.',
    typeDelete: 'Gib DELETE ein, um zu bestätigen.',
    success: 'Post gelöscht.',
    error: 'Post konnte nicht gelöscht werden. Bitte versuche es später erneut.',
  },
  posts: {
    showLatestPosts: '{count} neuen Post anzeigen | {count} neue Posts anzeigen',
    noPosts: 'Noch keine Posts',
    beFirstToPost: 'Was wolltest du schon immer mal wissen?',
  },
  adminFeedbackPromptLine1: 'Noch nicht die Antwort gefunden, die du brauchst?',
  requestAdminFeedback: 'Admin-Antwort anfordern',
  adminFeedbackRequestedOn: 'Du hast am {date} eine Admin-Antwort angefordert.',
  adminFeedbackRequestSuccess: 'Admin-Antwort wurde erfolgreich angefordert. Ein Admin wird so schnell wie möglich auf deinen Beitrag antworten.',
  adminFeedbackRequestError: 'Fehler beim Anfordern einer Admin-Antwort. Bitte versuche es später erneut.',
  adminReplyAlreadyRequested: 'Für diesen Beitrag wurde bereits die Antwort eines Administrators angefordert.',
}
